export const NavItemEnum = {
  SUITE: 'suite',
  BUNDLE: 'bundle',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  CMS: 'cms',
  OPERATIONS: 'operations',
  FREE: 'crm',
  COMMERCE: 'commerce'
};
export const SegmentedNavItems = {
  bundle: [NavItemEnum.SUITE, NavItemEnum.FREE, NavItemEnum.BUNDLE],
  core: [NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CMS, NavItemEnum.OPERATIONS, NavItemEnum.COMMERCE]
};